<template>
  <div class="set-email">
    <a-form
      :form="form"
    >
      <a-form-item
        label="自动触发："
      >
        <a-switch
          :checked="!!formData.auto"
          @change="onChangeSwitch"
        />
      </a-form-item>
      <a-form-item
        v-show="formData.auto"
        label="触发条件："
        class="trigger-box"
      >
        <p class="top-text">
          当录入/编辑询盘信息，符合以下条件时，自动给询盘信息中的邮箱地址发送收件
        </p>
        <div class="result-box clearfix">
          <div
            v-decorator="['triggervaluestr', {
              rules: [{
                required: !!formData.auto, message: '请至少选择一个'
              }],
              initialValue: formData.triggervaluestr
            }]"
            class="content fl"
          >
            <div v-html="formData.triggervaluestr" />
          </div>
          <a
            class="fs-blue fl edit-trigger-btn"
            @click="handleEditTrigger"
          >编辑</a>
        </div>
      </a-form-item>
      <a-form-item
        v-if="!formData.auto"
        label="收件人："
      >
        <a-select
          v-decorator="['contactid', {
            rules: [{
              required: !formData.auto, message: '请选择收件人'
            }],
            initialValue: formData.contactid
          }]"
          placeholder="请选择收件人"
          @change="handleChangeContactid"
        >
          <a-select-option
            v-for="option in contactNames"
            :key="option.id"
            :value="option.id"
          >
            {{ option.name }}
          </a-select-option>
        </a-select>
        <a
          class="fs-blue"
          @click="handleCreateList"
        >
          创建清单
        </a>
      </a-form-item>
      <a-form-item
        label="发件人："
      >
        <a-input
          v-decorator="['from', {
            rules: [{ required: false }],
            initialValue: formData.from
          }]"
          placeholder="请输入发件人"
          @change="handleInput($event, 'from')"
        />
        <p class="prompt">
          建议使用公司名称以便于收件人快速识别
        </p>
      </a-form-item>
      <a-form-item
        label="发件邮箱："
      >
        <a-input
          v-decorator="['fromemail', {
            rules: [{
              required: true, message: '请输入'
            }, {
              validator: checkEmail
            }],
            initialValue: formData.fromemail
          }]"
          placeholder="请输入发件邮箱"
          @change="handleInput($event, 'fromemail')"
        />
        <p class="prompt">
          建议使用公司邮箱以便于收件人快速识别
        </p>
      </a-form-item>
      <a-form-item
        label="回信地址："
      >
        <a-input
          v-decorator="['replyto', {
            rules: [{
              required: true, message: '请输入'
            }, { validator: checkEmail }],
            initialValue: formData.replyto
          }]"
          placeholder="请输入回信地址"
          @change="handleInput($event, 'replyto')"
        />
        <p class="prompt">
          收件人回复信件时，将回复至此邮箱地址
        </p>
      </a-form-item>
      <a-form-item
        label="邮件主题："
      >
        <a-input
          v-decorator="['subject', {
            rules: [{
              required: true, message: '请输入'
            }],
            initialValue: formData.subject
          }]"
          placeholder="请输入邮件主题"
          @change="handleInput($event, 'subject')"
        />
      </a-form-item>
      <a-form-item
        label="发送时间："
        class="send-time"
      >
        <a-radio-group
          v-decorator="['sendnow', {
            rules: [{
              required: true, message: '请选择'
            }],
            initialValue: formData.sendnow
          }]"
          @change="onChangeSendTime"
        >
          <a-radio
            :style="{ ...radioStyle, display: 'inline-block' }"
            :value="1"
          >
            立即发送
          </a-radio>
          <a-radio
            v-if="formData.auto"
            :style="radioStyle"
            :value="0"
          >
            <span>延迟</span>
            <number-add-input
              :value="delayHours"
              :min-num="0"
              text="小时"
              @change="handleInputDalay($event, 'hours')"
            />
            <number-add-input
              :value="delayMinutes"
              :min-num="0"
              :max-num="60"
              text="分钟"
              @change="handleInputDalay($event, 'minutes')"
            />
          </a-radio>
          <a-radio
            v-if="!formData.auto"
            :style="radioStyle"
            :value="0"
          >
            <span>排期</span>
            <!-- DOTO: 默认值处理 -->
            <a-form-item
              :validate-status="planDateError"
              :help="planDateError ? '日期不能为空' : ''"
            >
              <a-date-picker
                :value="datestring ? $moment(datestring, 'YYYY-MM-DD') : null"
                class="plan-time"
                @change="onChangePlanDate"
              />
            </a-form-item>
            <a-form-item
              :validate-status="planTimeError"
              :help="planTimeError ? '时间不能为空' : ''"
            >
              <a-time-picker
                :value="timestring ? $moment(timestring, 'HH:mm') : null"
                format="HH:mm"
                :minute-step="15"
                @change="onChangePlanTime"
              />
            </a-form-item>
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="发送结果通知："
      >
        <a-input
          v-decorator="['noticeemail', {
            rules: [{ validator: checkEmail }],
            initialValue: formData.noticeemail
          }]"
          placeholder="请输入"
          @change="handleInput($event, 'noticeemail')"
        />
        <p class="prompt">
          将邮件发送结果通知到该邮箱地址
        </p>
      </a-form-item>
    </a-form>
    <add-contact-modal
      :visible.sync="showAddContactModal"
      :has-name="true"
      @result="selecteContactResult"
    />
    <importContactFailModal
      :visible.sync="showImportContactFailMessage"
      @handleClick="handleLookFail"
      @hide="hideImportContactFailMessageVisible"
    />
    <a-modal
      v-model="showImportContactFailModal"
      title="添加失败的邮箱地址"
      :closable="true"
      :footer="false"
    >
      <div
        v-if="importContactResult && importContactResult.failArr"
        style="max-height: 200px; overflow: auto; margin-bottom: 20px; padding: 10px; border: solid 1px #dbdbdb; border-radius: 4px;"
      >
        <p
          v-for="(item, index) in importContactResult.failArr"
          :key="index"
          style="line-height: 30px;"
        >
          {{ item }}
        </p>
      </div>
    </a-modal>
    <trigger-modal
      :visible.sync="showTriggerModal"
      :emailid="emailid"
      :triggertype="formData.triggertype"
      :trigger-condition="triggerCondition"
      @setTriggerResult="setTriggerResult"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import NumberAddInput from '@/components/pc/NumberAddInput'
import AddContactModal from './../editContactList/AddContactModal'
import importContactFailModal from './../editContactList/ImportContactFailModal'
import TriggerModal from './TriggerModal'

export default {
  name: 'SetEmail',
  components: {
    NumberAddInput,
    AddContactModal,
    importContactFailModal,
    TriggerModal
  },
  props: {
    emailid: {
      type: [Number, String],
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      datestring: '',
      timestring: '',
      delayHours: 0,
      delayMinutes: 0,
      planDateError: '',
      planTimeError: '',
      showAddContactModal: false,
      showImportContactFailMessage: false,
      showImportContactFailModal: false,
      showTriggerModal: false,
      triggerCondition: {}
    }
  },

  computed: {
    ...mapState('edm/emailTable', ['contactNames']),
    ...mapState('edm/editContactList', ['importContactResult'])
  },

  watch: {
    formData: {
      handler (val) {
        if (val) {
          let { plantime = '', delaytime = '', contactid } = val

          if (typeof delaytime === 'number') {
            this.delayHours = parseInt(delaytime / 60)
            this.delayMinutes = delaytime % 60
          }

          if (plantime) {
            this.datestring = plantime.split(/\s+/ig)[0]
            this.timestring = plantime.split(/\s+/ig)[1]
          }

          if (contactid && this.contactNames.length) {
            let index = this.contactNames.findIndex(item => item.id === contactid)
            if (index === -1) {
              this.formData.contactid = undefined
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },

  mounted () {
    this.fetchContactName()
  },

  methods: {
    ...mapActions('edm/emailTable', ['fetchContactName']),
    ...mapActions('edm/editEmail', ['fetchTriggerCondition']),
    ...mapMutations('edm/editEmail', ['SET_EMAIL_INFO', 'SET_ERROR', 'SET_TRIGGER_CONFIG']),

    handleCreateList () {
      this.showAddContactModal = true
    },
    selecteContactResult (res) {
      if (this.importContactResult.successNum > 0) {
        this.fetchContactName()
      }
      if (this.importContactResult.failNum > 0) {
        this.showImportContactFailMessage = true
      }
    },
    handleLookFail () {
      this.showImportContactFailModal = true
    },
    hideImportContactFailMessageVisible (hide) {
      this.showImportContactFailMessage = false
    },
    async handleEditTrigger () {
      if (!this.triggerCondition.isEdit) {
        let chain = await this.fetchTriggerCondition({
          id: this.emailid
        })
        chain.onSuccess(res => {
          this.showTriggerModal = true
          this.triggerCondition = res
        })
      } else {
        this.showTriggerModal = true
      }
    },
    setTriggerResult (res = [], triggertype) {
      this.formData.triggervalue = res
      if (res.length) {
        this.triggerCondition.config = res
        this.triggerCondition.isEdit = true
        this.SET_TRIGGER_CONFIG({ config: this.triggerCondition.config })
        this.formData.triggervaluestr = res.map(item => item.string).join(';')
        this.formData.triggertype = triggertype

        this.form.setFieldsValue({
          'triggervaluestr': this.formData.triggervaluestr
        })
        this.form.validateFields(['triggervaluestr'])
      }
    },
    onChangeSwitch (checked) {
      this.formData.auto = checked ? 1 : 0
      this.formData.sendnow = 1
      this.formData.delaytime = 0
      this.formData.plantime = ''

      this.delayHours = 0
      this.delayMinutes = 0
      this.datestring = ''
      this.timestring = ''

      this.SET_EMAIL_INFO({ config: this.formData })
      this.$bus.$emit('resetTiggerAuto', this.formData.auto, this.formData.sendnow)

      setTimeout(() => {
        this.form.setFieldsValue({
          'sendnow': this.formData.sendnow,
          'delaytime': this.formData.delaytime,
          'plantime': this.formData.plantime
        })
        this.form.validateFields(['sendnow', 'delaytime', 'plantime'])
      }, 50)
    },

    handleInput (e, name) {
      let val = e.target.value
      this.formData[name] = val
    },
    handleChangeContactid (val) {
      this.formData.contactid = val
    },
    onChangeSendTime (e) {
      let val = e.target.value
      this.formData.sendnow = val

      this.SET_EMAIL_INFO({ config: this.formData })
      this.$bus.$emit('resetTiggerAuto', this.formData.auto, this.formData.sendnow)

      this.formData.plantime = ''
      this.datestring = ''
      this.timestring = ''
      this.planDateError = ''
      this.planTimeError = ''
    },
    onChangePlanDate (date, datestring) {
      this.datestring = datestring
      this.formData.plantime = datestring + ' ' + this.timestring

      this.planDateError = this.datestring ? '' : 'error'
    },
    onChangePlanTime (time, timestring) {
      this.timestring = timestring
      this.formData.plantime = this.datestring + ' ' + timestring

      this.planTimeError = this.timestring ? '' : 'error'
    },
    handleInputDalay (val, name) {
      if (name === 'hours') {
        this.delayHours = val
      }
      if (name === 'minutes') {
        this.delayMinutes = val
      }
      this.formData.delaytime = this.delayHours * 60 + this.delayMinutes * 1
    },
    checkEmail (rule, value, callback) {
      if (value && !/^[A-Za-z\d0-9]+([-_.][A-Za-z\d0-9]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,18}$/.test(value)) {
        rule.message = '邮箱不是有效的邮箱格式'
        callback(rule.message)
      }
      callback()
    },
    handleSubmit () {
      let _this = this

      if (!this.formData.sendnow) {
        this.planDateError = this.datestring ? '' : 'error'
        this.planTimeError = this.timestring ? '' : 'error'
      }

      return new Promise(function (resolve, reject) {
        _this.form.validateFields((err, values) => {
          if (!_this.formData.auto) {
            err = err || _this.planDateError === 'error' || _this.planTimeError === 'error'
          }
          if (!err) {
            _this.formData.auto = !_this.formData.auto ? 0 : 1

            _this.SET_EMAIL_INFO({ config: _this.formData })
            _this.SET_ERROR({ tab2Error: false })
            resolve(false)
          } else {
            _this.SET_ERROR({ tab2Error: true })
            resolve(true)
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.set-email {
  margin: 24px 0;
  padding-bottom: 40px;
}
::v-deep .ant-form-item-label {
  float: left;
  width: 180px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 180px;
}
.ant-switch {
  min-width: 40px;
}
.ant-input, .ant-select {
  width: 320px;
  margin-right: 16px;
}

.prompt {
  display: inline-block;
  color: #B3B3B3;
}
.trigger-box {
  .top-text {
    margin-bottom: 12px;
    color: #666;
  }
  .content {
    overflow: auto;
    display: inline-block;
    width: 320px;
    height: 80px;
    margin-right: 16px;
    padding: 4px 12px;
    word-break: break-all;
    border-radius: 4px;
    border: 1px solid #d6d6d6;
  }
  .edit-trigger-btn {
    line-height: 24px;
  }
}
.send-time {
  .ant-radio-wrapper ::v-deep {
    margin-bottom: 12px;
    .ant-form-item {
      display: inline-block;
      margin-left: 16px;
    }
    .ant-form-item-control-wrapper {
      padding-left: 0;
    }
  }
  .ant-radio-wrapper:first-child {
    display: inline-block;
  }
}
.plan-time {
  margin-right: 16px;
  ::v-deep .ant-input {
    width:  130px;
  }
}
</style>
